<!--:totalRecords="totalRecords"
:lazy="true"
--><!--:lazy="true"-->
<!--@filter="onFilter($event)"-->
<!--:filters="filters"-->
<!--@filter="onFilter($event)"-->
<!--stateStorage="session"
    stateKey="dt-state-demo-session"-->
<template>
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :first="firstRecordIndex"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column 
      v-for="c in model.getDisplayFields()"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getHeaderStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 40px; heigth: 40px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>

        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>

      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[$CommonList.getFieldFilter(c)]"
          class="p-column-filter"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
          :style="getHeaderStyle(c)"
        /><!-- :keyup="onFilter(c.filter.type,c.key)"-->
        <!--v-model="filters[getField(c)]"-->
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"
          @change="onFilter($event,c.filter.type,c.key)"
          :style="getHeaderStyle(c)"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <Calendar
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false"
          :monthNavigator="true"
          :yearNavigator="true"
          :yearRange="yearRange"
          dateFormat="yy-mm-dd"
          id="date_from"
          v-model="filters[getField(c)]"
          class="p-column-filter"
          :showIcon="true"
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          :placeholder="getFilterPlaceHolder(c)"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        {{ slotProps.data.color }}
        <Button
          v-for="(a, k) in actions.rows(slotProps.data)"
          :key="k"
          type="button"
          :icon="getIcon(a.icon)"
          :class="getClass(a.name)"
          :disabled="getDisabled(a.disabled)"
          style="margin: 2px"
          v-on:click="actionsClicked(k, a, slotProps)"
        ></Button>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      {{ $t('datatable.empty') }}
    </template>
    <template #loading>
      {{ $t('datatable.loading') }}
    </template>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
  },
  data() {
    return {
      yearRange : "2024:2200",
      //filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filters: {},
      filtersCustom: [],
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
    };
  },
  async created() {
    var year = new Date().getFullYear()
    var yearRange = '2024:'+(year+100);
    this.yearRange = yearRange+'';
    this.test = this.tableData;
    //this.listDataService = await this.dataList();
  },
  mounted () {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    //  filtersTmp:this.filters
    };
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        console.log("this.lazyParamsthis.lazyParams:"+this.page_transaction,this.lazyParams);
         this.firstRecordIndex = this.lazyParams.first;
        console.log("this.lazyParams:22222222",this.lazyParams);
       /* if (this.lazyParams){
          console.log("this.lazyParams.filters",this.lazyParams.filters);

        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {

    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'active':
          if(data.active == true){
            text = `<i  style="color: green" class="pi pi-check icon"></i>`;
          }else{
            text = `<i style="color: red" class="pi pi-times icon"></i>`;
          }
          break;
        // case 'type':
        //  text =  data.post ? data.post.type:'-'
        //     if (data.post.type){
        //       if (data.post.type == "LOOKING_FOR_A_TEAM"){
        //         text = "Opponent"
        //       }
        //      else if (data.post.type == "LOOKING_FOR_MERCENARY"){
        //         text = "Mercenary"
        //       }
        //       else if (data.post.type == "SCOUT_CLUB_TEAM_MEMBER"){
        //         text = "Scout"
        //       }
        //       else if (data.post.type == "APPLYING_TO_JOIN"){
        //         text = "Join club"
        //       }
        //       else if (data.post.type == "POST_ON_MY_CLUB"){
        //         text = "Only my club"
        //       }
        //       else if (data.post.type == "MATCH"){
        //         text = "Match"
        //       }
        //       else if (data.post.type == "LIFE"){
        //         text = "Posts"
        //       }
        //       else if (data.post.type == "SHOWING_OFF_YOUR_EQUIPMENT"){
        //         text = "Equipment"
        //       }
        //       else if (data.post.type == "QUESTION"){
        //         text = "Question"
        //       }
        //     }
        //     else {
        //       text = '-'
        //     }
        //   break;
        case 'title':
          if(data.post){
            text =  data.post.title ? data.post.title:"-"
          }
          break;

        case 'caption':
          if(data.post){
            if(data.post.caption ){
              if (data.post.caption.length > 50 ){
                text = data.post.caption.slice(0,50)+'...';
              }
              else {
                text = data.post.caption
              }
            }
            else {
              text = '-'
            }
          }
          break;

        case 'match':
          console.log("match",data.post)
          if(data.post){
            if(data.post.match == null){
              text = "-"
            }
            else {
              var created_at = data.post.match ? moment(data.post.match.created_at).format("MMM DD, YYYY hh:mm A"):"-"
              var stadium = data.post.match.stadium ? data.post.match.stadium.name:"-"
              text =  created_at + " - " + stadium
            }
          }
          break;
        case 'clubs':
          if(data.post){
             text =  data.post.clubs ? data.post.clubs.club_name:'-'
          }
          break;

        case 'creator':
          if(data.post){
            text = data.post.creator ? data.post.creator.fullname:"-"
          }
          break;
        case 'reason':
          if(data.post){
            text = data.reason_arr[0].name ? data.reason_arr[0].name:"-"
          }
          break;
        case 'report_by':
          if(data.post){
            text = data.report_by.fullname ? data.report_by.fullname:"-"
          }
          break;
        default:
      }
      return text;
    },



    callbackCustom(c,data){
      var text = ''
      switch(c.key) {
        case 'main_active_area':
          data.users.usere_main_area.length = data.users.usere_main_area.length ? data.users.usere_main_area.length:[]
          if(data.users.usere_main_area.length > 0){
            var map = []
            var province_id_map = []
            var tmp = data.users.usere_main_area ? data.users.usere_main_area:[]
            for (let i = 0; i < tmp.length; i++) {
              const e = tmp[i];
              if(e.district_id == null){
                let name_province = e.province.province_lang ? e.province.province_lang[0].name : ''
                if(name_province !== ''){
                  if(!province_id_map.includes(e.province_id)){
                    province_id_map.push(e.province_id)
                  }
                  map[e.province_id]={
                    province_id : e.province_id,
                    name: name_province,
                    is_all: true,
                    name_districts : ''
                  }
                }
              }else{
                if(province_id_map.includes(e.province_id)){
                  var checkdata = map[e.province_id]
                  if(checkdata.is_all == false){
                    let name_district = e.district.district_lang ? e.district.district_lang[0].name : ''
                    if(name_district !== ''){
                      map[e.province_id].name_district += '-'+name_district
                    }
                  }
                }else{
                  let name_province = e.province.province_lang ? e.province.province_lang[0].name : ''
                  let name_district = e.district.district_lang ? e.district.district_lang[0].name : ''
                  if(name_province !=='' && name_district!==''){
                    province_id_map.push(e.province_id);
                    map[e.province_id]={
                      province_id : e.province_id,
                      name: name_province,
                      is_all: false,
                      name_district: name_district
                    }
                  }
                }
              }
            }
            if(province_id_map.length > 0){
              for (let j = 0; j < province_id_map.length; j++) {
                var data_tmp = map[province_id_map[j]]
                if(data_tmp.is_all == true){
                  if(text !== ''){
                    text += '; '+data_tmp.name
                  }else{
                    text = data_tmp.name
                  }
                }else{
                  if(text !== ''){
                    text += '; '+data_tmp.name_district+','+data_tmp.name
                  }else{
                    text += data_tmp.name_district+','+data_tmp.name
                  }
                }
              }
            }
          }
          if(text.length > 100){
            text = text.slice(0,100)+'...'
          }
          break;
        case 'number_clubs':
          if(data.clubs_member_aggregate && data.clubs_member_aggregate.aggregate){
            var count = data.clubs_member_aggregate.aggregate.count
            // if(this.album_number == true){
            text = '<a href="#">' + count + '</a>(chưa chuyển trang)';
            // }else{
            //   text = '<a href="#">' + count + '</a>(chưa chuyển trang)';
            // }
          }else{
            text = 0;
          }
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },


    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      //console.log("colcolcol:",col);
      //console.log("rowrowrowrow:",row);
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("ll HH:mm");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy HH:mm");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      console.log("plaaaa",col.filter.type)
      console.log("col",col)
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select" || col.filter.type == "DateRange") {
        return `Choose `;
      } else if (col.filter.type == "input") {
        return `Input`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
   async dataList(lazyParams) {
      // console.log('lazyParams');
      // console.log('lazyParams:',lazyParams);
     var offset = lazyParams.first;
     var limit = lazyParams.rows;
     // console.log("dasddsadas",this.model.tableName);
     var gqLQueryList = DataServices.getList("report_post");
     var where = {
        post: {
          deleted: {_eq: false}
        },
       deleted: {_eq: false},
     }
     var filters = lazyParams.filters;
     if (filters){
        for (const [key, value] of Object.entries(filters)) {
          if (value.type_input == 'input'){
            if (!this.$commonFuction.isEmpty(value.value)){
              if (key == 'title'){
                where.post['plain_title']={_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"};
              }
              else if (key == 'caption'){
                where.post['plain_caption']={_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"};
              }
              else if (key == 'report_by'){
                where['report_by'] = {plain_fullname:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}};
                //  where['post'] = {post_report:{report_by:{plain_fullname:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}}};
              }
              else if (key == 'creator'){
                  where.post['creator']={plain_fullname:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}};
                // where['post'] = {creator:{plain_fullname:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}};
              }
              else if (key == 'match'){
                where.post['match']= {stadium :{plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}}
                //  where['post'] = {match:{stadium :{plain_name:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}}};
                //  console.log("stasium",where)
              }
              else if (key == 'clubs'){
                where.post['clubs']= {club_plainname:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}
                //  where['post'] = {clubs:{club_plainname:{_ilike: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}};
              }
              else if (key == 'main_active_area'){
                where['users'] = {usere_main_area:{district:{district_lang:{plain_name:{_like: "%"+this.$commonFuction.SkipVN(value.value)+"%"}}}}};
              }
              else {
                where[key] = {_like: "%"+value.value+"%"};
              }
            }
          }
          else if (value.type_input == 'DateRange'){
            if(value.value !== undefined && value.value !== null){

              if(key == "created_at"){
                where[key] = {'_gte': value.value.from,'_lte': value.value.to}
              }
              else {
                where[key] = {_eq: value.value}
              }
            }
          }
          else if(value.type_input == 'select'){
              if(key == "type"){
                if(value.value !== undefined && value.value !== null){
                  where.post['type'] = {_eq: value.value}
                  // where['post'] = {type:{_eq: value.value}}
                }
              }else if(key == "active"){
                if(value.value !== undefined && value.value !== null){
                  where['active'] = {_eq: value.value}
                }
              }
            }
        }

     }
     var resData = await this.$apollo.mutate({
       mutation: gqLQueryList,
       variables: {
         where_key:where ,
         offset:offset,
         limit:limit,
         orderBy:{updated_at: 'desc'}
       }
     });
     var listData = resData.data[this.model.tableName];
    //  console.log("listData",resData)

     var gqLQueryCount = DataServices.countData("report_post");
     var countRes = await this.$apollo.mutate({
       mutation: gqLQueryCount,
       variables: {
         where_key:where
       }
     });
     var total = countRes.data[this.model.tableName+'_aggregate']['aggregate']['count'];

     var dataRes = {
       listData: listData,
       total: total,
     };
    //  console.log('dataRes:',dataRes);
     return dataRes;
    },
    onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      // console.log('this.lazyParams:', this.lazyParams)
      this.loading = true;
      var that = this;
      this.dataList(this.lazyParams).then(data => {
        // console.log("datadata:", data)
        //var count = 0;
        data.listData = data.listData ? data.listData:[]
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          stt++;
          data.listData[i].stt = stt;
          if (data.listData[i].post){
            data.listData[i].type = data.listData[i].post.type
          }
          /*that.$CoreService.getImage(that.$constants.TYPE_IMAGE.USER, data.listData[i].id, i).then(dataRes => {
            count++;
            var key_list = dataRes.key_list;
            var list_image = dataRes.listData;//có 1 hình nhưng theo format list
            if (list_image.length > 0) {
              data.listData[key_list].avatar = list_image[0].url;
            }
            if (count == data.listData.length) {
              that.listDataService = data.listData;
              that.totalRecords = data.total;
              that.loading = false;
            }
          });*/

        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    onPage(event) {
      console.log("eventeventeventevent",event);
      this.lazyParams = event;
      this.onLazyEvent();
    },

    async onFilter(event,type_input,key) {
      this.tableData = this.test;
      if(type_input == "DateRange"){
        if(this.filters[key] !== null && this.filters[key][1]== null){
          return false;
        }
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);
      this.lazyParams.first = 0;
      this.onLazyEvent()
      /*setTimeout(() => {
        this.customers = this.datasource.slice(event.first, event.first + event.rows);
        this.loading = false;
      }, 500);*/
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
.p-column-filter{
  width: 100%!important;
}
.txt-width_50{
  max-width: 400px!important;
  width: 400px!important;
}
.txt-width_160{
  max-width: 200px!important;
  width: 200px!important;
}

.txt-mid{
  text-align: center!important;
}

.pi-check:before{
  font-size: 22px!important;
  font-weight: bold!important;
}
.pi-times:before{
  font-size: 22px!important;
  font-weight: bold!important;
}

.width-2{
  width: 17%!important;
  max-width: 17%!important;
}
.width-1{
  width: 9%!important;
  max-width: 9%!important;
}



</style>